// src/LoginSignupComponent.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useParams } from 'react-router-dom';
import { PHP_BASE_URL } from './apiBase';

export default function LoginSignupComponent() {
  const { eventId, code } = useParams(); 
  const navigate = useNavigate();
useEffect(() => {
  const token = localStorage.getItem('logintoken');
  if (token) {
    navigate(`/${eventId}/${code || ''}`, { replace: true });
  }
}, [navigate, eventId, code]);

  const [isLogin, setIsLogin] = useState(true);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);




  const handleLogin = async () => {
    if (!email || !password) {
      alert('Παρακαλούμε συμπληρώστε όλα τα κενά.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${PHP_BASE_URL}/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('logintoken', data.token);
navigate(`/${eventId}/${code || ''}`, { replace: true });
      } else {
        alert('Αποτυχία Σύνδεσης: ' + (data.error || 'Unknown error'));
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignUp = async () => {
    if (!name || !email || !password) {
      alert('Παρακαλούμε συμπληρώστε όλα τα κενά.');
      return;
    }
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!emailValid) {
      alert('Άκυρη Διεύθυνση Email');
      return;
    }
    if (password.trim().length < 8) {
      alert('Ο κωδικός πρέπει να περιλαμβάνει τουλάχιστον 8 χαρακτήρες.');
      return;
    }

    setLoading(true);
    try {
      const body = new URLSearchParams({ name, email, password }).toString();
      const res = await fetch(`${PHP_BASE_URL}/signup2.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('logintoken', data.token);
navigate(`/${eventId}/${code || ''}`, { replace: true });
      } else {
        alert('Σφάλμα εγγραφής: ' + (data.error || 'Unknown error'));
      }
    } catch (err) {
      alert(err.message);
    } finally { 
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Top left back button */}
<button onClick={() => navigate(-1)} style={styles.backButton}>
  <i className="fas fa-arrow-left"></i> Πίσω
</button>

<img
            src="https://upass.gr/logotransparent.png"
            alt="U-Pass Logo"
            className="logo"
          />
      <h1 style={styles.title}>{isLogin ? 'Συνδεθείτε' : 'Εγγραφείτε'}</h1>

      <div style={styles.formContainer}>
        {!isLogin && (
          <div style={styles.inputWrapper}>
            <input
              type="text"
              placeholder="Ονοματεπώνυμο"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={styles.input}
            />
          </div>
        )}

        <div style={styles.inputWrapper}>
          <input
            type="email"
            placeholder="Διεύθυνση Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.inputWrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Κωδικός"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            style={styles.showButton}
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>

        <button
          onClick={isLogin ? handleLogin : handleSignUp}
          style={{ ...styles.actionButton, opacity: loading ? 0.7 : 1 }}
          disabled={loading}
        >
          {loading ? 'Φόρτωση...' : isLogin ? 'Σύνδεση' : 'Εγγραφή'}
        </button>
      </div>

      <p onClick={() => setIsLogin((prev) => !prev)} style={styles.toggleText}>
        {isLogin ? 'Δημιουργία Νέου Λογαριασμού' : 'Συνδεθείτε'}
      </p>

      <a
        href="https://upass.gr/reset/reset.html"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.forgotLink}
      >
        Ξεχάσα τον κωδικό μου
      </a>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#000',
    padding: '20px',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
  },
 backButton: {
  position: 'absolute',
  top: 20,
  left: 20,
  background: 'none',
  border: 'none',
  color: '#fff',
  padding: '8px 15px', // Smaller vertical padding
  borderRadius: 24,
  cursor: 'pointer',
  fontSize: '1rem',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
},

  title: {
    marginBottom: '20px',
    fontSize: '2rem',
  },
  formContainer: {
    width: '100%',
    maxWidth: '400px',
    borderRadius: '15px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  },
  inputWrapper: {
    position: 'relative',
    marginBottom: '15px',
  },
  input: {
    width: '100%',
    padding: '12px 40px 12px 12px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
  },
  showButton: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: '#aaa',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  actionButton: {
    padding: '12px',
    fontSize: '1.1rem',
    background: 'linear-gradient(180deg, #ad0d02, #600501)',
    border: 'none',
    borderRadius: '8px',
    color: 'lightgray',
    cursor: 'pointer',
    fontWeight: '500',
  },
  toggleText: {
    color: '#C0C0C0',
    cursor: 'pointer',
    margin: '5px 0',
  },
  forgotLink: {
    color: '#C0C0C0',
    textDecoration: 'none',
    marginTop: '5px',
  },
};
